exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Renderer_renderer__3hRap {\n  position: relative;\n  flex: 1 1;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 0; }\n  .Renderer_renderer__3hRap:first-child {\n    border-top: none; }\n  .Renderer_renderer__3hRap .Renderer_title__1AlLd {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #505050;\n    color: #bbbbbb;\n    padding: 4px 6px;\n    font-size: 14px; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"renderer": "Renderer_renderer__3hRap",
	"title": "Renderer_title__1AlLd"
};